import translator from '@Components/Utilities/Translator';
import * as CurrencyFormatter from '@Components/Utilities/CurrencyFormatter';
import { bidCallerCollectionTypes } from '@Components/Utilities/SandhillsConstants';
import { useState, useMemo } from 'react';
import AlertPreferences from '@Components/AlertPreferences/AlertPreferences';
import CurrencyAlertPopUp from '@Components/Listings/CurrencyAlertPopUp';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import AutoBidIncrements from '@Components/Listings/AutoBidIncrements';

const BiddingConfirmation = (props) => {
    const [bidValue, setBidValue] = useState(props.UserBid);
    // Making use of useMemo because during the AT updates this value could otherwise change
    const formattedCurrentBid = useMemo(() => CurrencyFormatter.FormatCurrency(props.CurrentBid, props.CultureCode, props.CurrencyCode, 0, 0), [props.CurrentBid]);
    const formattedNextTieBid = useMemo(() => CurrencyFormatter.FormatCurrency(props.UserBid + props.Increment, props.CultureCode, props.CurrencyCode, 0, 0), [props.UserBid,props.Increment]);

    const routes = useRecoilValue(atoms.routes);

    const getFormattedCurrentBid = () => {
        return (<>{` ${props.CurrencyCode?.toUpperCase()} ${formattedCurrentBid}`}</>);
    };

    const getFormattedBid = () => {
        return (<>{` ${props.CurrencyCode?.toUpperCase()} ${CurrencyFormatter.FormatCurrency(bidValue, props.CultureCode, props.CurrencyCode, 0, 0)}`}</>);
    };

    const getFormattedSoldPrice = () => {
        return (<>{` ${props.CurrencyCode?.toUpperCase()} ${CurrencyFormatter.FormatCurrency(props.CollectionInfo.Quantity * bidValue, props.CultureCode, props.CurrencyCode, 0, 0)}`}</>);
    };

    const getAuctionPriceLabel = () => {
        return (<>{props.CollectionInfo.IsPerWeight ? ` ${props.CollectionInfo.AuctionPriceLabel}` : ''}</>);
    };

    const getEFBidConfirmedBody = () => {
        const confirmationText = translator.translate('sandhills.youhavesuccessfullysubmittedaprebid');

        return <>
            {props.showCurrencyPopUp ?
                <CurrencyAlertPopUp
                    confirmationTextHeader={confirmationText}
                    confirmationTextBody={`${translator.translate('sandhills.yourprebid')}:${getFormattedBid().props.children}`}
                    applyForFinancingURL={props.BidPopUpURL}
                />
                :
                <>
                    <h1 className='success'><strong>{confirmationText}</strong></h1>
                    <h2>{translator.translate('sandhills.prebidconfirmation')}</h2>
                    <h2>{translator.translate('sandhills.yourprebid')}:{getFormattedBid()}</h2>
                </>
            }
        </>
    }

    const getATBidConfirmedBody = () => {

        if (props.AutoOutbid) {
            return <>
                    <strong>{translator.translate('sandhills.tradepubwebsite.mvc.automaticallyoutbid')}</strong>
                    <br /><br />
                    <span dangerouslySetInnerHTML={{ __html: translator.translate('sandhills.tradepubwebsite.mvc.seehowbiddingworks').replace("{0}", `<a href=${routes.HowToBid} target="_blank">${translator.translate('sandhills.tradepubwebsite.mvc.howbiddingworks')}</a>`) }}></span>
                </>
        }
        else if (props.TieBid) {
            return <div className={'bidder-status_tie-bidder-text'} >
                <div>
                    <strong>{translator.translate('sandhills.tradepubwebsite.mvc.youarenothighbidder')}</strong>
                </div>
                <div>
                    <br />
                    <span dangerouslySetInnerHTML={{ __html: translator.translate('sandhills.tradepubwebsite.mvc.tieshighbid') }}></span>
                    <br />
                    {translator.translate('sandhills.tradepubwebsite.mvc.tiebidpolicy')}
                    <br />
                    <span dangerouslySetInnerHTML={{ __html: translator.translate('sandhills.tradepubwebsite.mvc.yournextbid').replace("{0}", `<strong>${formattedNextTieBid}</strong>`) }}></span>
                </div>
            </div>
        }

        return <>
            {props.showCurrencyPopUp ?
                <CurrencyAlertPopUp
                    confirmationTextHeader={translator.translate('sandhills.tradepubwebsite.mvc.highbid')}
                    confirmationTextBody={`${translator.translate('sandhills.tradepubwebsite.mvc.ifsomeoneoutbidsyou')}<br/>
                                            ${translator.translate('sandhills.tradepubwebsite.mvc.yourmaximumbid')}:${getFormattedBid().props.children}<br/>
                                            ${translator.translate('sandhills.currentbid')}:${getFormattedCurrentBid().props.children}`}
                    applyForFinancingURL={props.BidPopUpURL}
                />
                :
                <>
                    <h1 className='success'><strong dangerouslySetInnerHTML={{ __html: translator.translate('sandhills.tradepubwebsite.mvc.highbid') }}></strong></h1>
                    <h2>{translator.translate('sandhills.tradepubwebsite.mvc.ifsomeoneoutbidsyou')}</h2>
                    <h2>{translator.translate('sandhills.tradepubwebsite.mvc.yourmaximumbid')}:{getFormattedBid()}</h2>
                    <h2>{translator.translate('sandhills.currentbid')}:{getFormattedCurrentBid()}</h2>
                </>
            }
        </>
    }

    return (
        <div className='pre-bid-body'>
            {props.BidConfirmed ?
                <>
                    {props.IsAT ?
                        getATBidConfirmedBody()
                        :
                        getEFBidConfirmedBody()
                    }
                    
                    {props.notificationSettings !== null && props.notificationSettings !== undefined &&
                        <>
                        <div className="notification-header">
                            <h2 className='mobile-hide'>{translator.translate('sandhills.tradepubwebsite.mvc.interestedinalerts')}</h2>
                            <a className='account-button title' href={props.WatchlistUrl}>{translator.translate('sandhills.tradesites.mvc.viewmywatchlist')}</a>
                        </div>
                        <AlertPreferences IsModal={true} IsBidConfirmation={true} onClose={props.onClose} {...props.notificationSettings} />
                        </>
                    }
                </>
                :
                props.ErrorDetails.errorMessage ?
                    <>
                        <p className='error'>{props.ErrorDetails.errorMessage}</p>

                        {props.ErrorDetails.autoBidIncrementData ?
                            <>
                                <div className='error-html'>
                                    <AutoBidIncrements
                                        {...props.ErrorDetails.autoBidIncrementData}
                                        HighlightedBidIncrement={props.ErrorDetails.highlightedBidIncrement}
                                        CultureCode={props.CultureCode}
                                        CurrencyCode={props.CurrencyCode}                                        
                                    />
                                </div>
                            </>
                            : null}
                    </>                
                    :
                    <>                   
                        {props.confirmLargeBid ?
                            <>
                                <h1 className="bid-warning">{translator.translate('sandhills.warning').toUpperCase()}</h1>

                                <h2>
                                    <span dangerouslySetInnerHTML={{ __html: translator.translate('sandhills.tradepubwebsite.mvc.warningbidproposed').replace("{0}", `${getFormattedBid().props.children}`).replace("{1}", `${getFormattedCurrentBid().props.children}`) }}></span>
                                </h2>
                                <br />
                                <br />
                                <div>
                                    {translator.translate('sandhills.tradepubwebsite.mvc.warningbuttoninfo')}
                                </div>
                                <br />
                                <label>
                                    <input tabIndex='0' type='checkbox' onKeyDown={(e) => { if (e.key === 'Enter') props.setLargeBidConfirmChecked(!props.largeBidConfirmChecked) }} onChange={(e) => { props.setLargeBidConfirmChecked(!props.largeBidConfirmChecked) }} checked={props.largeBidConfirmChecked} />
                                    {translator.translate('sandhills.tradepubwebsite.mvc.confirmmybid')}
                                </label>
                            </>
                            :
                            <>
                                <div className='bid-listing-title'>
                                    <h2><strong>{translator.translate('sandhills.tradepubwebsite.mvc.listingyouarebiddingon')}:</strong></h2>
                                    {props.ListingSerialNumber ? 
                                        <p>
                                            {props.ListingTitle}&nbsp;
                                            <strong>{translator.translate('sandhills.tradepubwebsite.mvc.sn')}:</strong>
                                            &nbsp;{props.ListingSerialNumber}
                                        </p>
                                        :
                                        <p>
                                            {props.ListingTitle}
                                        </p>
                                    }                              
                                </div>
                                <div>
                                    <h1>{translator.translate('sandhills.tradepubwebsite.mvc.yourmaximumbid')}:{getFormattedBid()}</h1>
                                    {props.IsAT && <h2>{translator.translate('sandhills.currentbid')}:{getFormattedCurrentBid()}</h2>}
                                    {(props.CollectionInfo?.Listings &&
                                        [bidCallerCollectionTypes.ChoiceTimesTheMoney, bidCallerCollectionTypes.SplitTimesTheMoney, bidCallerCollectionTypes.TimesTheMoney].includes(props.CollectionInfo?.CollectionType)) &&
                                        <h3>{props.CollectionInfo.Quantity} x {getFormattedBid()}{getAuctionPriceLabel()} = {getFormattedSoldPrice()}{getAuctionPriceLabel()}</h3>}
                                    {!props.IsAT && <h1 className='bid-warning'>{translator.translate('sandhills.tradepubwebsite.mvc.prebidscannotbelowered')}</h1>}
                                    <br />
                                    <p dangerouslySetInnerHTML={{ __html: props.biddingAgreement.BiddingDisclaimerText }}></p>
                                </div>
                            </>
                        }
                    </>
            }
        </div>
    );
}

export default BiddingConfirmation;